module.exports = __webpack_public_path__ + "static/media/UnderConstruction.798c6ecf.svg";